<template>
    <nav
        aria-label="Hlavná navigácia"
        class="hidden md:block bg-transparent"
        :class="{ 'sticky top-[72px] z-10': !inHeader }"
    >
        <div class="px-4 md:px-0">
            <div class="flex w-full md:w-fit md:mx-auto gap-2 md:gap-6 overflow-x-auto scrollbar-hide pb-1">
                <NuxtLink
                    to="/sebapoznanie"
                    no-prefetch
                    :class="[
                        'relative py-2 md:py-3 px-3 md:px-4 text-xs md:text-sm font-semibold whitespace-nowrap inline-flex items-center gap-1.5 md:gap-2 rounded-full transition-all duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500',
                        isActive('sebapoznanie')
                            ? 'bg-[rgba(236,72,153,0.1)] text-[#ec4899] dark:text-[#f472b6]'
                            : 'text-[#4b4152] dark:text-txt-body hover:bg-[rgba(236,72,153,0.08)]'
                    ]"
                >
                    <CIcon name="heart-outline" class="size-4 md:size-5 text-[#ec4899]" />
                    <span>Sebapoznanie</span>
                </NuxtLink>

                <NuxtLink
                    to="/mentori"
                    no-prefetch
                    :class="[
                        'relative py-2 md:py-3 px-3 md:px-4 text-xs md:text-sm font-semibold whitespace-nowrap inline-flex items-center gap-1.5 md:gap-2 rounded-full transition-all duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500',
                        isActive('mentoring')
                            ? 'bg-[rgba(4,114,116,0.1)] text-[#047274] dark:text-primary-400'
                            : 'text-[#4b4152] dark:text-txt-body hover:bg-[rgba(4,114,116,0.08)]'
                    ]"
                >
                    <CIcon name="mentoring" class="size-4 md:size-5 text-[#047274] dark:text-primary-400" />
                    <span>Mentoring</span>
                </NuxtLink>

                <NuxtLink
                    to="/dobrobaza"
                    no-prefetch
                    :class="[
                        'relative py-2 md:py-3 px-3 md:px-4 text-xs md:text-sm font-semibold whitespace-nowrap inline-flex items-center gap-1.5 md:gap-2 rounded-full transition-all duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500',
                        isActive('dobrovolnictvo') || isActive('dobrobaza')
                            ? 'bg-[rgba(234,179,8,0.1)] text-[#eab308] dark:text-[#fbbf24]'
                            : 'text-[#4b4152] dark:text-txt-body hover:bg-[rgba(234,179,8,0.08)]'
                    ]"
                >
                    <CIcon name="volunteering" class="size-4 md:size-5 text-[#eab308]" />
                    <span>Dobrovoľníctvo</span>
                </NuxtLink>

                <NuxtLink
                    to="/praca"
                    no-prefetch
                    :class="[
                        'relative py-2 md:py-3 px-3 md:px-4 text-xs md:text-sm font-semibold whitespace-nowrap inline-flex items-center gap-1.5 md:gap-2 rounded-full transition-all duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500',
                        isActive('praca')
                            ? 'bg-[rgba(249,115,22,0.1)] text-[#f97316] dark:text-[#fb923c]'
                            : 'text-[#4b4152] dark:text-txt-body hover:bg-[rgba(249,115,22,0.08)]'
                    ]"
                >
                    <CIcon name="jobs" class="size-4 md:size-5 text-[#f97316]" />
                    <span>Práca</span>
                </NuxtLink>

                <NuxtLink
                    to="/vzdelavanie"
                    no-prefetch
                    :class="[
                        'relative py-2 md:py-3 px-3 md:px-4 text-xs md:text-sm font-semibold whitespace-nowrap inline-flex items-center gap-1.5 md:gap-2 rounded-full transition-all duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500',
                        isActive('vzdelavanie')
                            ? 'bg-[rgba(194,76,252,0.1)] text-[#c24cfc] dark:text-[#c084fc]'
                            : 'text-[#4b4152] dark:text-txt-body hover:bg-[rgba(194,76,252,0.08)]'
                    ]"
                >
                    <InternshipIcon class="size-4 md:size-5 text-[#c24cfc]" />
                    <span>Vzdelávanie</span>
                </NuxtLink>

                <NuxtLink
                    to="/pre-organizacie"
                    no-prefetch
                    :class="[
                        'relative py-2 md:py-3 px-3 md:px-4 text-xs md:text-sm font-semibold whitespace-nowrap inline-flex items-center gap-1.5 md:gap-2 rounded-full transition-all duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500',
                        isActive('pre-organizacie')
                            ? 'bg-[rgba(249,115,22,0.1)] text-[#f97316] dark:text-[#fb923c]'
                            : 'text-[#4b4152] dark:text-txt-body hover:bg-[rgba(249,115,22,0.08)]'
                    ]"
                >
                    <CIcon name="building" class="size-4 md:size-5 text-[#f97316]" />
                    <span>Pre organizácie</span>
                </NuxtLink>

                <NuxtLink
                    to="/blog"
                    no-prefetch
                    :class="[
                        'relative py-2 md:py-3 px-3 md:px-4 text-xs md:text-sm font-semibold whitespace-nowrap inline-flex items-center gap-1.5 md:gap-2 rounded-full transition-all duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500',
                        isActive('blog')
                            ? 'bg-[rgba(59,130,246,0.1)] text-[#3b82f6] dark:text-[#60a5fa]'
                            : 'text-[#4b4152] dark:text-txt-body hover:bg-[rgba(59,130,246,0.08)]'
                    ]"
                >
                    <Icon name="heroicons:book-open" class="size-4 md:size-5 text-[#3b82f6]" />
                    <span>Blog</span>
                </NuxtLink>
            </div>
        </div>
    </nav>
</template>

<script setup lang="ts">
defineProps<{
    inHeader?: boolean
}>()

const route = useRoute()
function isActive(path: string): boolean {
    // Check if current route path starts with the given path
    // This handles nested routes like /mentoring/pre-mentee
    return (
        route.path.startsWith(`/${path}`) ||
        route.name?.toString().toLowerCase().includes(path.toLowerCase()) ||
        (path === 'mentoring' && (route.path.startsWith('/mentori') || route.name?.toString().includes('mentor'))) ||
        (path === 'internships' &&
            (route.path.startsWith('/internships') || route.name?.toString().includes('internship')))
    )
}
</script>

<style scoped>
/* Hide scrollbar but keep functionality */
.scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
    display: none;
}
</style>
